import Layout from '@/views/layout'
export default {
  path: '/fault',
  menuName: '故障管理',
  component: Layout,
  name: 'fault',
  meta: { title: 'fault', icon: 'fault', iconType: 'svg' },
  children: [
    {
      path: 'code',
      name: 'faultCode',
      menuName: '故障码维护',
      component: () => import('@/views/fault/faultCode'),
      meta: { title: 'faultCode', icon: 'faultCode', iconType: 'svg' }
    },
    {
      path: 'historyError',
      name: 'historyError',
      menuName: '故障信息',
      component: () => import('@/views/fault/historyError'),
      meta: { title: 'historyError', icon: 'historyError', iconType: 'svg' }
    }
  ]
}